import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-unauth-passport-form',
  templateUrl: './unauth-passport-form.component.html',
  styleUrls: ['./unauth-passport-form.component.scss'],
})
export class UnauthPassportFormComponent {
  @Input() showStamp = true;
}
